<template>
	
    <div class="post-wrap series-post-wrap">

        <div class="series-post-single">
            <div class="series-post-img">
                <img src="../../assets/images/posts-img/series-post.jpeg" alt="series-post" />
            </div>
            <div class="series-post-desc">
                <a href="#">Voldemort</a>
                <p>Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter and The Party Hellows</p>
                <ul>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/eye.svg" alt="eye-icon" />
                      <span>10 Reads</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/heart-fill.svg" alt="heart-icon" />
                      <span>20 Voted</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/episode.svg" alt="episode-icon" />
                      <span>6 Episode</span>
                    </li>
                </ul>

                <div class="story-tag" >
                    <button>test</button>
                    <button>test</button>
                </div>
            </div>  
        </div><!-- /.series-post-single -->
        <div class="series-post-single">
            <div class="series-post-img">
                <img src="../../assets/images/posts-img/series-post.jpeg" alt="series-post" />
            </div>
            <div class="series-post-desc">
                <a href="#">Voldemort</a>
                <p>Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter and The Party Hellows</p>
                <ul>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/eye.svg" alt="eye-icon" />
                      <span>10 Reads</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/heart-fill.svg" alt="heart-icon" />
                      <span>20 Voted</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/episode.svg" alt="episode-icon" />
                      <span>6 Episode</span>
                    </li>
                </ul>

                <div class="story-tag" >
                    <button>test</button>
                    <button>test</button>
                </div>
            </div>  
        </div><!-- /.series-post-single -->
        <div class="series-post-single">
            <div class="series-post-img">
                <img src="../../assets/images/posts-img/series-post.jpeg" alt="series-post" />
            </div>
            <div class="series-post-desc">
                <a href="#">Voldemort</a>
                <p>Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter and The Party Hellows</p>
                <ul>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/eye.svg" alt="eye-icon" />
                      <span>10 Reads</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/heart-fill.svg" alt="heart-icon" />
                      <span>20 Voted</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/episode.svg" alt="episode-icon" />
                      <span>6 Episode</span>
                    </li>
                </ul>

                <div class="story-tag" >
                    <button>test</button>
                    <button>test</button>
                </div>
            </div>  
        </div><!-- /.series-post-single -->
        <div class="series-post-single">
            <div class="series-post-img">
                <img src="../../assets/images/posts-img/series-post.jpeg" alt="series-post" />
            </div>
            <div class="series-post-desc">
                <a href="#">Voldemort</a>
                <p>Story series about Tom Riddle aka Lord Voldemort, a huge villain of Harry Potter and The Party Hellows</p>
                <ul>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/eye.svg" alt="eye-icon" />
                      <span>10 Reads</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/heart-fill.svg" alt="heart-icon" />
                      <span>20 Voted</span>
                    </li>
                    <li>
                      <img class="heart-icon" src="../../assets/icon/episode.svg" alt="episode-icon" />
                      <span>6 Episode</span>
                    </li>
                </ul>

                <div class="story-tag" >
                    <button>test</button>
                    <button>test</button>
                </div>
            </div>  
        </div><!-- /.series-post-single -->
       
    </div>

</template>

<script>


export default {
    name: "series-post",


    data(){
        return{
   
        }
    },

    methods: {
       
    }

}

</script>
